<template>
    <div class="appdetail">
        <el-drawer :visible.sync="drawer" custom-class="detailDrawer" size="100%" :withHeader="false" :modal-append-to-body="true" :modal="false" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.5)">
            <!-- 标题、按钮 -->
            <div class="appdetail-title">
                <div class="appdetail-title-top clearfix">
                    <div class="app-titles">
                        <i :class="currentSelectMenuData.css" class="app-title-icon"></i>
                        <span class="app-title-main">{{title}}</span> 
                    </div>
                    <div class="app-buttons">
                        <i class="el-icon-close appdetail-close" @click="closeBtn"></i>
                    </div>
                </div>
            </div>
            <div class="appdetail-content" :style="{height: 'calc(100vh - 91px)'}">
          <iframe
            v-show="isShow"
            id="bdIframe"
            :src="designurl"
            width="100%"
            :height="fullHeight"
            frameborder="0"
            scrolling="auto"
            ref="editIframe"
          ></iframe>
          <!-- <previewPage v-show="!isShow" ref="previewPage"></previewPage> -->
        <!-- </div> -->
        <div class="content-footer">
          <el-button size="small" type="warning" @click="againCreatePage" v-show="isagainCreatePage">重新生成页面</el-button>
          <el-button size="small" type="warning" @click="preview" v-show="isShow">预览</el-button>
          <el-button size="small" type="primary" @click="save()" v-show="isShow">保存</el-button>
          <el-button size="small" @click="close" v-show="isShow">取消</el-button>
          <el-button size="small" @click="back" v-show="!isShow">返回</el-button>
        </div>
      </div>
        </el-drawer>
  </div>
</template>
<script>
// import previewPage from "@/components/customPages/previewPage.vue";

export default {
  name: "layoutiframe",
  components: {
    // previewPage: previewPage
  },
  data() {
    return {
      drawer:false,
      show: false,
      title: "编辑布局",
      fullHeight: document.documentElement.clientHeight - 130 + 'px',//获取浏览器高度
      loading: false, //默认加载数据时显示loading动画
      isdefaultmax: true,
      jsonData: {}, //编辑器的json数据
      dataInfo: null,
      ispreview: true,
      isShow: true,
      isagainCreatePage:false,
      str:'',
      designurl:Config.designerurl_url
    };
  },
  methods: {
    open(dataInfo,str) {
      this.str = str
      this.drawer = true;
      // this.show = true;
      this.back();
      this.dataInfo = dataInfo;
      var url = Config.dev_url + "/api-apps/appcfg/" + this.dataInfo.id;
      this.$axios.get(url, {}).then(res => {
        if (res.status == 200) {
          console.log("res.data", res.data);
          this.jsonData = res.data.pagelayout;
          var jsonDatas = JSON.parse(res.data.pagelayout);
          //向表单设计器页面传递json
          let iframeWin = this.$refs.editIframe.contentWindow;
          iframeWin.postMessage(
            {
              cmd: "sendFormJson",
              params: jsonDatas
            },
            "*"
          );
        } else {
          this.$message.warning(res.statusText);
        }
      }).catch((err) => {
      });;
      this.getRoleInfo({})
      this.getAppData({})
    },
    againCreatePage(){
        var str = 'convertLayoutJson'
        this.generatePage(this.dataInfo,str)
    },
    generatePage(dataInfo,str) {
      if (dataInfo.pagelayout !== null && dataInfo.pagelayout !== undefined && dataInfo.pagelayout !== '') {
          this.isagainCreatePage = true;
      }else{
          this.isagainCreatePage = false;
      }
      if (!!dataInfo.id) {
        this.dataInfo = dataInfo;

      if(!!str){
          var url = Config.dev_url + "/api-demand/demand/convertLayoutJson/" + this.dataInfo.id;
      }else{
        var url = Config.dev_url + "/api-demand/demand/getLayoutJson/" + this.dataInfo.id;
      }
        this.$axios.get(url, {}).then(res => {
          console.log(res)
          // if (res.data.code == 0) {
          //   this.$message({
          //     message: res.data.msg,
          //     type: "success"
          //   });
          this.drawer = true;
            // this.show = true;
            this.back();
            console.log("res.data", res.data);
            this.jsonData = res.data;
            // var jsonDatas = JSON.parse(res.data);
            //向表单设计器页面传递json
            let iframeWin = this.$refs.editIframe.contentWindow;
            iframeWin.postMessage(
              {
                cmd: "sendFormJson",
                params: this.jsonData
              },
              "*"
            );
          // }else {
          //   this.$message({
          //     message: res.data.msg,
          //     type: "error"
          //   });
            // this.$message.warning(res.statusText)
          // }
        }).catch((err) => {
      });;
      } else {
        this.$message({
          message: "请先保存数据",
          type: "warning"
        });
      }
      this.getRoleInfo({})
    },
    close() {
      this.drawer = false;
      // this.show = false;
    },
    back() {
      this.isShow = true;
      this.title = "编辑布局";
    },
    preview() {
      this.isShow = false;
      this.title = "预览界面";
      console.log(this.dataInfo,"主数据")
      console.log(this.jsonData, "json数据");
      // var  jsonDatas = JSON.parse(this.jsonData)
      if(!!this.dataInfo.demandegname){
          var appName = this.dataInfo.demandegname + 'App'
      }
      // this.$refs.previewPage.view(this.jsonData,appName);
    },
    //将表单设计器的json存入数据库
    save() {
      //保存页面
        var jsonDatas = JSON.stringify(this.jsonData);
        if(this.str == '应用管理'){
            var url1 = Config.dev_url + "/api-apps/appcfg/saveOrUpdate";
            this.dataInfo.pagelayout = jsonDatas;
            this.$axios.post(url1, this.dataInfo).then(res => {
            if (res.data.code == 0) {
              this.loading = false;
              this.$message({
                message: "保存成功",
                type: "success"
              });
            } else {
              // this.show = true;
              if (res.data.code == 1) {
                this.loading = false;
                //res.data.msg!=''后台返回提示信息
                if (res.data.msg != "") {
                  this.$message({
                    message: res.data.msg,
                    type: "error"
                  });
                }
              }
            }
          }).catch((err) => {
          });
        }else{
          console.log(this.dataInfo.id,jsonDatas, "保存的数据");
          var url = Config.dev_url + "/api-demand/demand/updateJson/" + this.dataInfo.id
          this.$axios.post(url,this.$qs.parse(this.jsonData)).then((res)=>{
              console.log(res,"保存json结果")
              if(res.data.code == 0){
                  this.$message.success(res.data._msg)
              }else{
                  this.$message.warning(res.data.msg)
              }
          }).catch((err) => {
          });
        }
      },
      //获取角色信息
      getRoleInfo(obj){
          if(!!obj.page && !!obj.limit){
              var data = {page:obj.page,limit:obj.limit}
          }else{
            var data = {page:1,limit:10}
          }
          for(let key in obj){
             if(key != 'page' && key !='limit'){
                data[key] = obj[key]
             }
          }
          var url = Config.dev_url + '/api-user/roles'
          this.$axios.get(url,{params:data}).then((res)=>{
              console.log(res,"角色信息")
              var roleData = res.data
              let iframeWin = this.$refs.editIframe.contentWindow;
              iframeWin.postMessage({
                  cmd: 'sendRoleData',
                  params: roleData
              }, '*');
          }).catch((err) => {
          });
      },
      //获取app信息
      getAppData(obj){
          if(!!obj.page && !!obj.limit){
              var data = {page:obj.page,limit:obj.limit}
          }else{
            var data = {page:1,limit:10}
          }
          for(let key in obj){
             if(key != 'page' && key !='limit'){
                data[key] = obj[key]
             }
          }
          var url = Config.dev_url + '/api-apps/appcfg'
          this.$axios.get(url,{params:data}).then((res)=>{
              console.log(res,"应用程序")
              var appData = res.data
              let iframeWin = this.$refs.editIframe.contentWindow;
              iframeWin.postMessage({
                  cmd: 'sendAppData',
                  params: appData
              }, '*');
          }).catch((err) => {
          });
      },
      //关闭抽屉按钮点击
      closeBtn(){
          this.drawer = false
      },
      //计算抽屉大小
      initDetailDrawer(){
          if((document.documentElement.clientWidth * 0.7) < 900){
              document.getElementsByClassName("detailDrawer")[0].parentNode.parentNode.style.left = "calc(100% - 900px)"
          }else{
              document.getElementsByClassName("detailDrawer")[0].parentNode.parentNode.style.left = "30%"
          }
      },
    },
  mounted(){
      //接收表单设计器页面的json
      window.addEventListener('message', (event) => {
        if(event.data.cmd == 'sendAppSearchList'){
            this.getAppData(event.data.params)
        }
        if(event.data.cmd == 'sendRoleSearchList'){
            this.getRoleInfo(event.data.params)
        }
        if(event.data.cmd == 'getFormJson'){
          this.jsonData = event.data.params
        }
      });
      this.initDetailDrawer()  //初始化计算详情抽屉高度
      //窗口大小发生变化时，重新计算详情抽屉高度
      window.onresize = ()=> {
          if(document.getElementsByClassName("detailDrawer").length > 0){
              this.initDetailDrawer()
          }
      }
  },
  computed:{
        //当前左侧菜单选中的信息
        currentSelectMenuData(){
            return this.$store.state.currentSelectMenuData
        },
        //左侧菜单以及应用详情抽屉显示状态
        menuAndDrawer(){
            return this.$store.state.menuAndDrawer
        },
        //当前登录人信息
        currentuser() {
            return this.$store.state.currentuser
        },
    },
}
</script>
<style scoped>
@import "../../../assets/css/mask-modules.css";
</style>
